import MotoristaTelefoneService from "@/services/MotoristaTelefoneService";

export const motoristaTelefone = {
  namespaced: true,
  state: {
    motoristaTelefone: {},
  },
  actions: {
    getMotoristaTelefone({ commit }, payload) {
      return MotoristaTelefoneService.GetMotoristaTelefone(payload).then(
        (motoristaTelefone) => {
          return Promise.resolve(motoristaTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postMotoristaTelefone({ commit }, payload) {
      return MotoristaTelefoneService.PostMotoristaTelefone(payload).then(
        (motoristaTelefone) => {
          return Promise.resolve(motoristaTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putMotoristaTelefone({ commit }, payload) {
      return MotoristaTelefoneService.PutMotoristaTelefone(payload).then(
        (motoristaTelefone) => {
          return Promise.resolve(motoristaTelefone);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteMotoristaTelefone({ commit }, payload) {
      return MotoristaTelefoneService.DeleteMotoristaTelefone(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getMotoristaTelefoneOData({ commit }, payload) {
      return MotoristaTelefoneService.GetMotoristaTelefoneOData(payload).then(
        (motoristaTelefone) => {
          return Promise.resolve(motoristaTelefone);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default motoristaTelefone;
